<template>
    <Page header="Пользователь" type="" :nopadding="false" header_pos="left">
        <template #body>
            <div class="w-full flex flex-column gap-2">
                <div v-for="(value, key) in user" :key="key">
                    <span class="text-normal text-500">{{ key }}: </span>
                    <span class="text-normal flex">
                        {{ value }}
                        <span v-if="value === null">
                            (null)
                        </span>
                    </span>
                </div>
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import AdminUserList from '@/components/admin/user/list.vue'
import Page from '@/components/public/page.vue'
import { useRoute } from 'vue-router'

export default {
    data() {
        return {
            loading: false,
            user_id: null,
            user: {}
        }
    },
    components: {
        AdminUserList,
        Page
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        async LoadUser(user_id) {
            console.log('LoadUser', user_id)
            if(!user_id) return
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const res = await this.connect.GetAdminUserById(user_id).then(res=>res)
            console.log('GetAdminUserById', res)
            if(res.result) {
                this.user = res.data
            } else {
                this.user = {}
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке пользователя')
            }
            this.loading = false
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        
        
    },
    async mounted() {
        const route = useRoute() 
        if(route.params.id!='' && this.helper.is_id(route.params.id)){
            this.user_id = route.params.id           
            this.LoadUser(this.user_id)
        } else {
            this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Неверный ID пользователя', life: 3000 });
            this.user = {}
        }
    },
}
</script>